const products = {
    launch: {
        id: 'plan_GdFBu6UP2BmElM',
        price: 10,
    },
    default: {
        id: process.env.VUE_APP_STRIPE_DEFAULT_PLAN_ID,
        price: 20,
    },
};

function getStripeProduct(companyCreatedAt, subscriptionStatus) {
    // HACK: This is a temporary hack to display the launch price for companies
    const dateBeforePriceIncrease = new Date('2023-12-05');
    const parsedCompanyCreatedAt = new Date(companyCreatedAt);
    const isValidDate = companyCreatedAt && !isNaN(parsedCompanyCreatedAt.getTime());
    if (subscriptionStatus !== 'canceled' && isValidDate && parsedCompanyCreatedAt < dateBeforePriceIncrease) {
        return products.launch;
    }

    return products.default;
}

module.exports = {
    getStripeProduct,
};
